import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import "./index.css";
import App from "./App";
import { store } from "./redux/configure-store";
import * as serviceWorker from "./serviceWorker";

const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
